<template>
    <!-- Preview -->
    <section class="slider py-24 overflow-hidden">
        <div class="container">
            <h2 class="landing-h2 text-center mb-8">
                <template v-for="currentBlok in blok.headline">
                    <span :class="[currentBlok.hasColorGradient ? 'gradient-dark' : '']">{{ currentBlok.text }}&nbsp;</span> 
                </template>
            </h2>
            <div class="overflow-visibleb bg-gradient-to-r from-indigo-900 to-indigo-500 rounded-3xl mt-12">
              <div class="flex transition-transform duration-1000 py-12 gap-x-4" :style="{ transform: `translateX(-${currentSlide * 100}%)` }">
                  <div class="flex-shrink-0 w-full flex justify-center" v-for="(member, idx) in slides" :key="idx">
                    <div class="bg-white rounded-2xl shadow-lg overflow-hidden w-full max-w-md">
                      <img :src="member.image" :alt="member.name" class="w-full h-96 object-cover">
                      <div class="p-4 text-center">
                        <div class="font-semibold text-lg">{{ member.name }}</div>
                        <div class="text-sm text-gray-600">{{ member.position }}</div>
                      </div>
                </div>
              </div>
                  </div>
                  <div class="flex justify-center space-x-2 bg-white px-6 pt-4 rounded-t-2xl mx-auto w-fit">
                    <button
                      v-for="(slide, index) in slides"
                      :key="index"
                      @click="goToSlide(index)"
                      :class="index === currentSlide ? 'w-3 h-3 rounded-full bg-indigo-600' : 'w-3 h-3 rounded-full bg-gray-200'"
                    ></button>
                  </div>
            </div>
        </div>
    </section>
</template>

<script setup>
    defineProps({ blok: Object })

    // Slider
    import { onMounted, ref } from 'vue'
    // Beispiel: Team-Mitglieder mit Bild, Name und Position
    const slides = [
      { image: '/Ibo.jpg', name: 'Ibrahim', position: 'CEO / Founder' },
      { image: '/Saliha.jpg', name: 'Saliha', position: 'COO / Founder' },
      { image: '/Peter.jpg', name: 'Peter', position: 'Software Engineer' },
      { image: '/Dawid.jpg', name: 'Dawid', position: 'Software Engineer' },
      { image: '/Alekos.jpg', name: 'Alekos', position: 'Webdesign & Content Marketing' }
    ];
    const currentSlide = ref(0);

    function goToSlide(index) {
      currentSlide.value = index;
    }

    onMounted(() => {
      setInterval(() => {
        currentSlide.value = (currentSlide.value + 1) % slides.length;
      }, 5000);
    });
</script>